export interface Program {
  title: string;
  slug: string;
  more: string;
  dark?: boolean;
  video: string;
  intro?: number;
  info?: {
    title: string;
    sub: string;
    type?: string;
    length?: string;
    genre?: string;
  }
}

export type ProgramList = Program[];

const programList: ProgramList = [
  {
    title: "Atlanctic Crossing",
    slug: "atlancticcrossing",
    more: "https://www.betafilm.com/en/product/d/atlantic-crossing.html",
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f7ae921f8739b7b8d062635-598082b12e58a50b2d302ab7-vod-progressive--2508f8ed.ism/video.mp4",
    intro: 92.5,
    info: {
      title: "Atlantic Crossing",
      sub: "Based on true events: the untold story of the Norwegian Crown Princess becoming a very influential figure in world politics during World War II, starring Sofia Helin (The Bridge) and Kyle MacLachlan (Twin Peaks).",
      type: "Limited Series",
      length: "8 x one hour",
      genre: "Drama, History",
    },
  },
  {
    title: "Tell Me Who I Am",
    slug: "tellmewhoiam",
    more: "https://www.betafilm.com/en/product/d/tell-me-who-i-am.html",
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f7d9a9e5d6a2f4ee94beab2-598082b12e58a50b2d302ab7-vod-progressive--138499a0.ism/video.mp4",
    info: {
      title: "Tell Me Wo I Am",
      sub: "Based on the global bestseller “Dime Quién Soy” by Julia Navarro with more than one million copies sold in 18 countries.",
      type: "Limited Series",
      length: "9 x one hour",
      genre: "Drama, History",
    },
  },
  {
    title: "3 Caminos",
    slug: "3caminos",
    more: "https://www.betafilm.com/en/product/d/3-caminos-4817.html",
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f7d9a97a5dcfd2961471fc3-598082b12e58a50b2d302ab7-vod-progressive--2ef0f65e.ism/video.mp4",
    info: {
      title: "3 Caminos",
      sub: "Beta cooperation with Ficción Producciones and Amazon Spain in view of the upcoming Compostela Holy Year 2021, when a record number of pilgrims will walk the Way of St. James.",
      type: "Limited Series",
      length: "8 x one hour",
      genre: "Drama",
    },
  },
  {
    title: "Alive and Kicking",
    slug: "aliveandkicking",
    more: "https://www.betafilm.com/en/product/d/alive-and-kicking.html",
    dark: true,
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f7d9a963c7e8b177925912a-598082b12e58a50b2d302ab7-vod-progressive--320f9e05.ism/video.mp4",
    intro: 91,
    info: {
      title: "Alive and Kicking",
      sub: "STAND BY ME meets ONE FLEW OVER THE CUCKOO’S NEST – the new series by Albert Espinosa, creator of RED BAND SOCIETY.",
      type: "Series",
      length: "7 x 25 minutes",
      genre: "Drama, Young Adult",
    },
  },
  {
    title: "Autentic",
    slug: "autentic",
    more: "https://www.autentic-distribution.com/146/MIPCOM-2020.htm",
    dark: true,
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f7d9a98abc45f49780e1542-598082b12e58a50b2d302ab7-vod-progressive--7933f2c4.ism/video.mp4",
    info: {
      title: "Autentic",
      sub: "Autentic Distribution is the sales division of Autentic GmbH and a subsidiary of the Beta-Group. Equipped to offer a wide-range of factual productions spanning a broad thematic base in different genres, our diverse and exclusive portfolio satisfies the demands of a changing international market. Autentic Distribution caters to the public and private commercial broadcasting sectors, VOD services and other relevant platforms.",
      type: "",
      length: "",
      genre: "",
    },
  },
  {
    title: "Kids and Family",
    slug: "kidsandfamily",
    more: "https://www.betafilm.com/en/search/do/market.html?id=9058",
    dark: true,
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f7ae9268dc9bc723113895b-598082b12e58a50b2d302ab7-vod-progressive--9765ead6.ism/video.mp4",
    info: {
      title: "Happy Day News",
      sub: "This year the Beta Film Kids & Family line-up will be presented online in a very special format. Featured, among others, are the International Emmy® Award-winning web series LIKE ME, the feature film JACKIE AND OOPJEN, where the famous subject of a Rembrandt portrait vanishes from the painting to look for her sister, and TALKING HEADS, the reality show where Kids found out what many already know: the hairdresser is the better therapist.",
    },
  },
  {
    title: "Labyrinth of Peace",
    slug: "labyrinthofpeace",
    more: "https://www.betafilm.com/en/product/d/labyrinth-of-peace.html",
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f71c034ec8baa01105cbf6a-598082b12e58a50b2d302ab7-vod-progressive--71e7b4c0.ism/video.mp4",
    info: {
      title: "Labyrinth of Peace",
      sub: "High-budget portrait of an industrial family dynasty. Inspired by true yet little-known events in post-WWII “neutral” Switzerland. From the producers of European box-office hit HEIDI.",
      type: "Limited Series",
      length: "6 x one hour",
      genre: "Drama, History",
    },
  },
  {
    title: "Louis van Beethoven",
    slug: "louisvanbeethoven",
    more: "https://www.betafilm.com/en/product/d/louis-van-beethoven.html",
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f71c03eec8baa01105cbf6f-598082b12e58a50b2d302ab7-vod-progressive--c017012a.ism/video.mp4",
    info: {
      title: "Louis van Beethoven",
      sub: "Beethoven has always been passionate about three things: music, freedom and verity. His battle against musical and social conventions lasts all his life – but his opus will last forever.",
      type: "Movie",
      length: "Two hours",
      genre: "Drama, History",
    },
  },
  {
    title: "The Sea Beyond",
    slug: "theseebeyond",
    more: "https://www.betafilm.com/en/product/d/the-sea-beyond-wt.html",
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f7db5f9fc38c97bd515cef2-598082b12e58a50b2d302ab7-vod-progressive--34875ee3.ism/video.mp4",
    intro: 123,
    info: {
      title: "The Sea Beyond",
      sub: "In a juvenile detention center at the Gulf of Naples, the inmates are dealing with power structures and adult expectations. Yet being locked up does not stop them from dreaming of a better tomorrow.",
      type: "Series",
      length: "12 x 50  and 10 x 50 minutes",
      genre: "Drama, Young Adult",
    },
  },
  {
    title: "Dead Mountain",
    slug: "deadmountain",
    more: "https://www.betafilm.com/en/product/d/dead-mountain-the-dyatlov-pass-incident.html",
    video: "https://vodvmsusoaws-cf.rtl.de/proxy195/vms/world-5f7d9a9ee2e33c172c521592-598082b12e58a50b2d302ab7-vod-progressive--691f8b87.ism/video.mp4",
    intro: 300,
    info: {
      title: "Dead Mountain -<br>The Dyatlov Pass Incident",
      sub: "Based on the de-classified files of the real-life case that had people spinning wild theories all over the world for more than 60 years, ranging from avalanches, to secret weapon tests, to alien interference.",
      type: "Series",
      length: "8 x one hour",
      genre: "Drama, Thriller",
    },
  },
];

export default programList;
